/**
 * These are the possible keys to use localStorage.
 */
export enum LocalStorageKeys {
  Modules = "modules",
  PlannerFilters = "plannerFilters",
  DefaultPlannerView = "default-planner-view",
  LoopbackAccessTokenId = "$LoopBack$accessTokenId",
  RelativeAccessFlowAccessToken = "RelativeAccessFlowAccessToken",
  DoNotShowNonStandardFilterWarning = "DoNotShowNonStandardFilterWarning",
}

export enum SessionStorageKeys {
  AuthModule = "auth.module",
  PostLoginURL = "postLoginURL",
}

export enum FileAcceptTypes {
  OnlyPDF = ".pdf",
  OnlyImage = "image/*",
  OnlyDocument = ".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ImageOrDocument = ".odp,.ods,.odt,.doc,.dot,.png,.pdf,.ppt,.rtf,.xls,.xml,.gif,.bmp,.pps,.txt,.msg,.jpg,.jpeg,.docx,.dotx,.docm,.dotm,.xlsx,.xltx,.xlsm,.xltm,.xlsb,.pptx",
}

export enum FileSizes {
  Max5MB = 5 * 1024 * 1024, // 5 MB in bytes
  Max10MB = 10 * 1024 * 1024, // 10 MB in bytes
  Max15MB = 15 * 1024 * 1024, // 15 MB in bytes
  Max50MB = 50 * 1024 * 1024, // 50 MB in bytes
  Max100MB = 100 * 1024 * 1024, // 100 MB in bytes
}

export enum IFrameMessage {
  /**
   * Sending a message to the iframed old manager when the instutiton is changed
   */
  InstitutionChanged = "institution-changed",

  /**
   * Sending a message to the iframed old manager when a view (booking, meetings,
   * etc.) is iframed. This is for sharing the authentication information with
   * the iframed content.
   */
  InitFromNewManager = "init-from-new-manager",

  /**
   * The planner module is the part of this project (vue-manager). But it is used
   * as iframed from the old manager. This is a message from the iframed planner
   * to the old manager. It says that it's ready to get authentication info
   * from the old manager.
   */
  PingAuthenticationInfo = "ping-authentication-info",

  /**
   * This is a message that comes from the old manager to the iframed new manager.
   * It contains auth info (token, instutition). The new manager uses that info
   * to init authStore properly because many GQL requests are dependent to the
   * authStore.
   */
  PongAuthenticationInfo = "pong-authentication-info",
}
